import { createSelector } from '@ngrx/store';

import { AppState } from 'store/root-reducer';

import { DocumentActions, DocumentActionTypes } from 'store/actions/document.actions';


export interface State {
  loading: Array<DocumentActionTypes>;
  err: string | undefined;
}

const initialState: State = {
  loading: [],
  err: undefined,
};

export function reducer(state: State = initialState, action: DocumentActions): State {
  switch (action.type) {
    case DocumentActionTypes.DELETE_DOCUMENT: {
      return {
        ...state,
        loading: [...state.loading, action.type]
      };
    }
    case DocumentActionTypes.DELETE_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: clearLoading(state, DocumentActionTypes.DELETE_DOCUMENT)
      };
    }
    case DocumentActionTypes.DELETE_DOCUMENT_FAILURE: {
      return {
        ...state,
        err: action.payload,
        loading: clearLoading(state, DocumentActionTypes.DELETE_DOCUMENT)
      };
    }
    default: {
      return state;
    }
  }
}

const document = (state: AppState) => state.document;

export const Selectors = {
  getLoading: createSelector(document, (state: State) => state.loading),
  getErrors: createSelector(document, (state: State) => state.err),
};

function clearLoading(authState: State, action: DocumentActionTypes): Array<DocumentActionTypes> {
  return authState.loading.filter((loadingMarker: DocumentActionTypes) => loadingMarker !== action);
}
